import React from "react";
import Success from "../../assets/Images/Success.svg";
import { connect } from "react-redux";
import "./Confirmation.css";
import Layout from '../../HOC/Layput/Layout'
const Confirmation = props => {
  document.title = "VK Global Publications |  Confirmation"

  sessionStorage.clear();

  return (
    <div>
            <div className="confirmation">
              <img
                className="text-center-confirmation"
                width="100"
                height="100"
                src={Success}
                alt = "success"
              />
              <h1 className="text-center">Thank You ! </h1>
              <h4 className="text-center">Your Order has been confirmed! </h4>
              <h6 className="text-center">
                {props.order[0].buyer_name}, Your order Id is{" "}
                <b>{props.order[0].id}</b>{" "}
              </h6>
            </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    order: state.book.orderStatus
  };
};

export default Layout(connect(mapStateToProps, null)(Confirmation), "Confirmation ");
